import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import type { ViewStyle } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { primitive, shadows, spacing } from 'styles/constants';

export const MapContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.mapContainer, isDesktop && styles.mapContainerDesktop, style],
  });
};

export const PressableStoreContainer = Pressable.withConfig({
  flexDirection: 'row',
  justifyContent: 'space-between',
  backgroundColor: primitive.$white,
  paddingX: '$4',
  paddingY: '$3',
  height: '$24',
  overflow: 'hidden',
  shadow: '1',
});

export const BoldText = withTypography({ variant: 'headerThree', m: '$0' });

export const Address = withTypography({ variant: 'copyOne' });

export const Directions = withTypography({
  variant: 'copyOne',
  my: '$1',
  style: { textDecorationLine: 'underline' },
});

type PickUpTimeContainerProps = BoxProps & {
  showBorderRadius?: boolean;
};

export const PickUpTimeContainer = ({
  showBorderRadius = true,
  style,
  ...props
}: PickUpTimeContainerProps) =>
  React.createElement(Box, {
    ...props,
    style: [
      styles.pickUpTimeContainer,
      showBorderRadius && styles.pickUpTimeContainerWithBorderRadius,
      style,
    ],
  });

export const PickUpWindowAlertContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.pickUpWindowAlertContainer, style],
  });

export const PickUpWindowAlert = withTypography({
  variant: 'copyOne',
  bold: true,
  fontSize: 'xs',
  ml: '$1',
});

const styles = StyleSheet.create({
  mapContainer: {
    height: spacing.$40,
  },
  mapContainerDesktop: {
    height: spacing.$48,
  },
  pickUpTimeContainer: {
    ...shadows.$1,
    backgroundColor: primitive.$white,
    borderStyle: 'solid',
    borderTopColor: primitive.$greyFive,
    borderTopWidth: 1,
    flexDirection: 'column',
    height: spacing.$24,
    overflow: 'hidden',
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$3,
  } as ViewStyle,
  pickUpTimeContainerWithBorderRadius: {
    borderBottomLeftRadius: primitive.$borderRadius,
    borderBottomRightRadius: primitive.$borderRadius,
  },
  pickUpWindowAlertContainer: {
    ...shadows.$1,
    alignItems: 'center',
    backgroundColor: primitive.$errorLight,
    borderBottomLeftRadius: primitive.$borderRadius,
    borderBottomRightRadius: primitive.$borderRadius,
    borderStyle: 'solid',
    borderTopColor: primitive.$greyFive,
    borderTopWidth: 1,
    flexDirection: 'row',
    height: spacing.$9,
    overflow: 'hidden',
    paddingHorizontal: spacing.$4,
  } as ViewStyle,
});
